import { Fragment } from 'react';
import * as React from 'react';
import FlowEventFilterRenderer from 'flow-doctor-lib/components/filters/FlowEventFilterRenderer';
import WalmartFilterBranchOperatorLabel from 'flow-doctor-lib/components/filters/WalmartFilterBranchOperatorLabel';
import ListEventTriggerRenderer from 'flow-doctor-lib/components/filters/ListEventTriggerRenderer';
import StyledAccordionFilterContainer from 'flow-doctor-lib/components/filters/StyledAccordionFilterContainer';
import WalmartFilterBranchRenderer from 'flow-doctor-lib/components/filters/WalmartFilterBranchRenderer';
import styled, { useTheme } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PaddingContainer = styled.div.withConfig({
  displayName: "WalmartEventEnrollmentFilters__PaddingContainer",
  componentId: "sc-1yg6sf-0"
})(({
  theme
}) => `
  padding: ${theme.space['0']};
`);
const WalmartEventEnrollmentFilters = ({
  portalId,
  flowEventFilters,
  flowObjectTypeId,
  condensed = false,
  listEventTriggers = [],
  persistedReEnrollmentLists = []
}) => {
  const theme = useTheme();
  return /*#__PURE__*/_jsxs(StyledAccordionFilterContainer, {
    condensed: condensed,
    children: [listEventTriggers.map((list, i) => /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(ListEventTriggerRenderer, {
        associatedList: list
      }), (i < listEventTriggers.length - 1 || flowEventFilters.length > 0 || persistedReEnrollmentLists.length > 0) && /*#__PURE__*/_jsx(WalmartFilterBranchOperatorLabel, {
        filterBranchOperator: "OR"
      })]
    }, list.listId)), persistedReEnrollmentLists.map((list, i) => /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(PaddingContainer, {
        theme: theme,
        children: /*#__PURE__*/_jsx(WalmartFilterBranchRenderer, {
          bordered: false,
          objectTypeId: flowObjectTypeId,
          filterBranch: list.filterBranch,
          filterWidthType: 'DEFAULT'
        })
      }), (i < persistedReEnrollmentLists.length - 1 || flowEventFilters.length > 0) && /*#__PURE__*/_jsx(WalmartFilterBranchOperatorLabel, {
        filterBranchOperator: "OR"
      })]
    }, list.listId)), flowEventFilters.map((flowEventFilter, i) => /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(FlowEventFilterRenderer, {
        portalId: portalId,
        flowObjectTypeId: flowObjectTypeId,
        flowEventFilter: flowEventFilter,
        debugFilter: flowEventFilter.debugFilter,
        filterWidthType: "WITH_FILTER_DETAILS"
      }), i < flowEventFilters.length - 1 && /*#__PURE__*/_jsx(WalmartFilterBranchOperatorLabel, {
        filterBranchOperator: "OR"
      })]
    }, flowEventFilter.eventFilterId.id))]
  });
};
export default WalmartEventEnrollmentFilters;